<template>
    <div class="row">
        <div class="col-12">
            <div class="d-flex align-items-center justify-content-between mb-4">
                <h4><i class="fas fa-history"></i> Histórico de {{ title }}</h4>
                <div>
                    <button
                        class="btn active btn-outline-secondary btn-sm"
                        :title="`Voltar para aba de ${title}`"
                        @click="$emit('voltar')"
                    >
                        <i class="mdi mdi-arrow-left"></i>Voltar
                    </button>
                </div>
            </div>
        </div>
        <loading-animation
            :active.sync="loading"
            :is-full-page="false"
            :opacity="1"
            color="#5895FF"
        />
        <div class="col-md-6 mb-3" v-for="item in itens" :key="item.id">
            <div class="card border" v-if="item.data">
                <div class="card-header bg-gray">
                    <p><b>Data</b> {{ item.data }}</p>
                    <p><b>Técnico</b> {{ item.tecnico }}</p>
                </div>
                <div class="card-body">
                    <p>
                        <b>Cadastro nacional de Saúde(CNS)</b>
                        {{ item.cns }}
                    </p>
                    <p>
                        <b>Tem deficiência?</b>
                        {{ pergunta(item.deficiencia) }}
                    </p>
                    <p>
                        <b>Data de início da deficiência</b>
                        {{ dateConverter(item.deficiencia_data_inicio) }}
                    </p>
                    <p>
                        <b>Qual é o tipo de deficiência?</b>
                    </p>
                    <ul>
                        <li>
                            <b>Cegueira</b> {{ pergunta(item.def_cegueira) }}
                        </li>
                        <li>
                            <b>Baixa Visão</b>
                            {{ pergunta(item.def_baixa_visao) }}
                        </li>
                        <li>
                            <b>Surdez severa/profunda</b>
                            {{ pergunta(item.def_surdez_servera) }}
                        </li>
                        <li>
                            <b>Surdez leve/moderada</b>
                            {{ pergunta(item.def_surdez_leve) }}
                        </li>
                        <li>
                            <b>Deficiência física</b>
                            {{ pergunta(item.def_fisica) }}
                        </li>
                        <li>
                            <b>Deficiência mental ou intelectual</b>
                            {{ pergunta(item.def_mental_intelectual) }}
                        </li>
                        <li>
                            <b>Síndrome de Down</b>
                            {{ pergunta(item.def_sindrome_down) }}
                        </li>
                        <li>
                            <b>Transtorno/doença mental</b>
                            {{ pergunta(item.def_transtorno_doenca_mental) }}
                        </li>
                    </ul>
                    <p>
                        <b
                            >Em função dessa deficiência, recebe cuidados
                            permanentes de terceiros?</b
                        >
                    </p>
                    <ul>
                        <li>
                            <b>Não</b> {{ pergunta(item.ajuda_nao_recebida) }}
                        </li>
                        <li>
                            <b>Sim, de alguém da família</b>
                            {{ pergunta(item.ajuda_familia) }}
                        </li>
                        <li>
                            <b>Sim, de cuidador especializado</b>
                            {{ pergunta(item.ajuda_especializada) }}
                        </li>
                        <li>
                            <b>Sim, de vizinho</b>
                            {{ pergunta(item.ajuda_vizinhos) }}
                        </li>
                        <li>
                            <b>Sim, de instituição da rede socioassistencial</b>
                            {{ pergunta(item.ajuda_instituicao) }}
                        </li>
                        <li>
                            <b>Sim, de outra forma</b>
                            {{ pergunta(item.ajuda_outra_forma) }}
                        </li>
                    </ul>
                    <p>
                        <b>Nome do responsável pelos cuidados</b>
                        {{ item.responsavel_nome }}
                    </p>
                    <p>
                        <b
                            >Faz uso de remédios controlados (tarja preta) para
                            transtornos mentais?</b
                        >
                        {{ pergunta(item.uso_remedio_controlado) }}
                    </p>
                    <p>
                        <b>Nome do Medicamento</b>
                        {{ item.remedio_controlado_nome }}
                    </p>
                    <p>
                        <b>Faz uso abusivo de álcool?</b>
                        {{ pergunta(item.uso_abusivo_drogas) }}
                    </p>
                    <p>
                        <b
                            >Faz uso abusivo de crack ou outras drogas (cocaína,
                            maconha etc)?</b
                        >
                        {{ pergunta(item.uso_abusivo_drogas) }}
                    </p>
                    <p><b>Tempo de uso?</b> {{ item.droga_tempo_uso }}</p>
                    <p>
                        <b>Período de uso?</b>
                        {{
                            verificarResposta(
                                item.droga_periodo_uso,
                                $root.arrays.periodo
                            )
                        }}
                    </p>
                    <p>
                        <b>Possui questões de saúde?</b>
                        {{ pergunta(item.portador_doenca) }}
                    </p>
                    <p><b>Nome da doença?</b> {{ item.doenca_nome }}</p>
                    <p>
                        <b>Nome do estabelecimento</b>
                        {{ item.estabelecimento_saude_nome }}
                    </p>
                    <p>
                        <b>Nome do Código do estabelecimento</b>
                        {{ item.estabelecimento_saude_codigo }}
                    </p>
                </div>
            </div>
            <div v-else>
                <div v-if="itens.length <= 1">
                    <h4 class="text-secondary">
                        <i class="mdi mdi-24px mdi-alert-decagram-outline"></i>
                        Não possui histórico ainda.
                    </h4>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "Historico",
    props: ["id", "tipo", "title"],
    data() {
        return {
            loading: true,
            itens: {},
        };
    },
    mounted() {
        this.getItens();
    },
    methods: {
        getItens() {
            axios
                .get(`api/dashboard/usuarios/historico/${this.tipo}/${this.id}`)
                .then((response) => {
                    this.itens = response.data;
                    this.loading = false;
                });
        },
        replace(string, search, change) {
            return string; //string.replaceAll(search, change);
        },
        dateConverter(date) {
            if (date) {
                return moment(date).format("DD/MM/YYYY");
            } else {
                return "";
            }
        },
        pergunta(item) {
            var value = item == 1 ? 0 : 1;
            return this.$root.arrays.pergunta[value].value;
        },
        verificarResposta(resposta, array) {
            if (resposta) {
                const result = array.filter((item) => item.id == resposta);
                return result[0] ? result[0].value : "";
            } else {
                return "";
            }
        },
    },
};
</script>
